module.exports = __webpack_public_path__ + "static/media/icon_doctor.b22016ec.svg";